export const passesPageRules = ({
  displayPages,
  displayPagesExclude,
  displayPagesInclude
}) => {
  const pagesData = {
    displayPagesInclude,
    displayPagesExclude,
    allPages: []
  };

  /*
    remove from url: protocol, www., / and query params - from the end
  */
  const clearUrl = (url) =>
    url.replace(/(http(s)?:\/\/)|(www\.)|(\/(\?.*)?$)/g, '');

  const getPredefinedPattern = (name) => {
    const host = clearUrl(document.location.host);
    const predefinedPatterns = {
      homepage: '(\\/)?(index\\.(.*))?($|\\?)'
    };

    return predefinedPatterns[name] ? `${host}${predefinedPatterns[name]}` : '';
  };

  const getFinalPattern = (pattern) => {
    return pattern
      .replace(/[/.+?^${}()|[\]\\]/g, '\\$&')
      .replace(/\*/g, '[^?].*?');
  };

  const checkMatch = (url, pattern) => {
    if (!url || !pattern) {
      return false;
    }

    const predefinedPattern = getPredefinedPattern(pattern);
    if (predefinedPattern) {
      return new RegExp(predefinedPattern).test(url);
    }

    if (pattern.includes('*')) {
      return new RegExp(getFinalPattern(pattern)).test(url);
    }

    return url === pattern;
  };

  const displayPagesFinally = {
    allPages: 'allPages',
    excludedPages: 'displayPagesExclude',
    specificPages: 'displayPagesInclude'
  }[displayPages];

  const pagesList = pagesData[displayPagesFinally];
  if (!pagesList.length) {
    return true;
  }

  const locationUrl = clearUrl(
    window.location.origin + window.location.pathname
  );

  return pagesList.find((page) => checkMatch(locationUrl, clearUrl(page.url)))
    ? displayPages !== 'excludedPages'
    : displayPages === 'excludedPages';
};
